/*** IMPORTS FROM imports-loader ***/
var define = false;

import keys from './keys.js';

// Retrieve the values of an object's properties.
export default function values(obj) {
  var _keys = keys(obj);
  var length = _keys.length;
  var values = Array(length);
  for (var i = 0; i < length; i++) {
    values[i] = obj[_keys[i]];
  }
  return values;
}




//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/values.js
// module id = 17
// module chunks = 0